<!-- page title -->
<app-page-title [breadcrumbItems]="pageTitle" title="Projects"></app-page-title>

<!-- end page title -->
<div class="row">
    <div class="col-12">
        <div class="card widget-inline">
            <div class="card-body p-0">
                <div class="row g-0">
                    <div class="col-sm-6 col-xl-3">
                        <div class="card shadow-none m-0">
                            <div class="card-body text-center">
                                <i class="dripicons-briefcase text-muted" style="font-size: 24px;"></i>
                                <h3><span>29</span></h3>
                                <p class="text-muted font-15 mb-0">Total Projects</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-3">
                        <div class="card shadow-none m-0 border-start">
                            <div class="card-body text-center">
                                <i class="dripicons-checklist text-muted" style="font-size: 24px;"></i>
                                <h3><span>715</span></h3>
                                <p class="text-muted font-15 mb-0">Total Tasks</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-3">
                        <div class="card shadow-none m-0 border-start">
                            <div class="card-body text-center">
                                <i class="dripicons-user-group text-muted" style="font-size: 24px;"></i>
                                <h3><span>31</span></h3>
                                <p class="text-muted font-15 mb-0">Members</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-3">
                        <div class="card shadow-none m-0 border-start">
                            <div class="card-body text-center">
                                <i class="dripicons-graph-line text-muted" style="font-size: 24px;"></i>
                                <h3><span>93%</span> <i class="mdi mdi-arrow-up text-success"></i></h3>
                                <p class="text-muted font-15 mb-0">Productivity</p>
                            </div>
                        </div>
                    </div>

                </div> <!-- end row -->
            </div>
        </div> <!-- end card-box-->
    </div> <!-- end col-->
</div>
<!-- end row-->

<div class="row">
    <div class="col-lg-4">
        <div class="card">
            <div class="card-body">
                <ng-container *ngTemplateOutlet="ProjectMenu"></ng-container>
                <h4 class="header-title mb-4">Project Status</h4>

                <div class="my-4 chartjs-chart" style="height: 202px;">
                    <canvas id="project-status-chart" baseChart [datasets]="doughnutChart.datasets"
                        [labels]="doughnutChart.labels" [chartType]="doughnutChartType"
                        [options]="doughnutChartOptions">
                    </canvas>
                </div>

                <div class="row text-center mt-2 py-2">
                    <div class="col-4">
                        <i class="mdi mdi-trending-up text-success mt-3 h3"></i>
                        <h3 class="fw-normal">
                            <span>64%</span>
                        </h3>
                        <p class="text-muted mb-0">Completed</p>
                    </div>
                    <div class="col-4">
                        <i class="mdi mdi-trending-down text-primary mt-3 h3"></i>
                        <h3 class="fw-normal">
                            <span>26%</span>
                        </h3>
                        <p class="text-muted mb-0"> In-progress</p>
                    </div>
                    <div class="col-4">
                        <i class="mdi mdi-trending-down text-danger mt-3 h3"></i>
                        <h3 class="fw-normal">
                            <span>10%</span>
                        </h3>
                        <p class="text-muted mb-0"> Behind</p>
                    </div>
                </div>
                <!-- end row-->

            </div> <!-- end card body-->
        </div> <!-- end card -->
    </div><!-- end col-->

    <div class="col-lg-8">
        <div class="card">
            <div class="card-body">
                <ng-container *ngTemplateOutlet="ProjectMenu"></ng-container>
                <h4 class="header-title mb-3">Tasks</h4>

                <p><b>107</b> Tasks completed out of 195</p>

                <div class="table-responsive">
                    <table class="table table-centered table-nowrap table-hover mb-0">
                        <tbody>
                            <ng-container *ngFor="let task of taskList">
                                <tr>
                                    <td>
                                        <h5 class="font-14 my-1"><a href="javascript:void(0);" class="text-body">
                                                {{task.taskName}}</a></h5>
                                        <span class="text-muted font-13">Due in {{task.dueDays}} days</span>
                                    </td>
                                    <td>
                                        <span class="text-muted font-13">Status</span> <br />
                                        <span class="badge"
                                            [class]="task.status==='In-progress' ? 'badge-warning-lighten' : task.status==='Outdated' ? 'badge-danger-lighten' : 'badge-success-lighten' ">{{task.status}}</span>
                                    </td>
                                    <td>
                                        <span class="text-muted font-13">Assigned to</span>
                                        <h5 class="font-14 mt-1 fw-normal">{{task.assignee}}</h5>
                                    </td>
                                    <td>
                                        <span class="text-muted font-13">Total time spend</span>
                                        <h5 class="font-14 mt-1 fw-normal">{{task.timeSpend}}</h5>
                                    </td>
                                    <td class="table-action" style="width: 90px;">
                                        <a href="javascript: void(0);" class="action-icon"> <i
                                                class="mdi mdi-pencil"></i></a>
                                        <a href="javascript: void(0);" class="action-icon"> <i class="mdi mdi-delete"
                                                (click)="removeTask(task)"></i></a>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div> <!-- end table-responsive-->

            </div> <!-- end card body-->
        </div> <!-- end card -->
    </div><!-- end col-->
</div>
<!-- end row-->

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <ng-container *ngTemplateOutlet="ProjectMenu"></ng-container>

                <h4 class="header-title mb-4">Tasks Overview</h4>

                <div class="mt-3 chartjs-chart" style="height: 320px;">
                    <canvas id="task-area-chart" baseChart [datasets]="barChart.datasets" [labels]="barChart.labels"
                        [chartType]="barChartType" [options]="barChartOptions"></canvas>

                </div>

            </div> <!-- end card body-->
        </div> <!-- end card -->
    </div><!-- end col-->
</div>
<!-- end row-->

<div class="row">
    <div class="col-xl-5">
        <div class="card">
            <div class="card-body">
                <ng-container *ngTemplateOutlet="ProjectMenu"></ng-container>

                <h4 class="header-title mb-3">Recent Activities</h4>

                <div class="table-responsive">
                    <table class="table table-centered table-nowrap table-hover mb-0">
                        <tbody>
                            <ng-container *ngFor="let activity of recentActivities">
                                <tr>
                                    <td>
                                        <div class="d-flex align-items-start">
                                            <img class="me-2 rounded-circle" [src]="activity.employeeProfile" width="40"
                                                alt="Generic placeholder image">
                                            <div>
                                                <h5 class="mt-0 mb-1">{{activity.employeeName}}<small
                                                        class="fw-normal ms-3">{{activity.date}}</small></h5>
                                                <span class="font-13">{{activity.description}}...</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span class="text-muted font-13">Project</span> <br />
                                        <p class="mb-0">{{activity.projectName}}</p>
                                    </td>
                                    <td class="table-action" style="width: 50px;">
                                        <ng-container *ngTemplateOutlet="TableMenu"></ng-container>

                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div> <!-- end table-responsive-->

            </div> <!-- end card body-->
        </div> <!-- end card -->
    </div><!-- end col-->

    <div class="col-xl-7">
        <div class="card">
            <div class="card-body">
                <ng-container *ngTemplateOutlet="ProjectMenu"></ng-container>

                <h4 class="header-title mb-3">Your Calendar</h4>

                <div class="row">
                    <div class="col-md-7">
                        <div class="calendar-widget">
                            <ngb-datepicker #dp [(ngModel)]="model"></ngb-datepicker>
                        </div>
                    </div> <!-- end col-->
                    <div class="col-md-5">
                        <ul class="list-unstyled">
                            <li class="mb-4">
                                <p class="text-muted mb-1 font-13">
                                    <i class="mdi mdi-calendar"></i> 7:30 AM - 10:00 AM
                                </p>
                                <h5>Meeting with BD Team</h5>
                            </li>
                            <li class="mb-4">
                                <p class="text-muted mb-1 font-13">
                                    <i class="mdi mdi-calendar"></i> 10:30 AM - 11:45 AM
                                </p>
                                <h5>Design Review - Hyper Admin</h5>
                            </li>
                            <li class="mb-4">
                                <p class="text-muted mb-1 font-13">
                                    <i class="mdi mdi-calendar"></i> 12:15 PM - 02:00 PM
                                </p>
                                <h5>Setup Github Repository</h5>
                            </li>
                            <li>
                                <p class="text-muted mb-1 font-13">
                                    <i class="mdi mdi-calendar"></i> 5:30 PM - 07:00 PM
                                </p>
                                <h5>Meeting with Design Studio</h5>
                            </li>
                        </ul>
                    </div> <!-- end col -->
                </div>
                <!-- end row -->

            </div> <!-- end card body-->
        </div> <!-- end card -->
    </div><!-- end col-->

</div>
<!-- end row-->

<!-- reusable template -->
<ng-template #ProjectMenu>
    <div class="float-end" ngbDropdown placement="bottom-end">
        <a ngbDropdownToggle class="arrow-none card-drop" id="projectDropdown" href="javascript:void(0)"
            aria-expanded="false">
            <i class="mdi mdi-dots-vertical"></i>
        </a>
        <div ngbDropdownMenu aria-labelledby="projectDropdown">
            <!-- item-->
            <a ngbDropdownItem routerLink="/">Weekly Report</a>
            <!-- item-->
            <a ngbDropdownItem routerLink="/">Monthly Report</a>
            <!-- item-->
            <a ngbDropdownItem routerLink="/">Action</a>
            <!-- item-->
            <a ngbDropdownItem routerLink="/">Settings</a>
        </div>
    </div>
</ng-template>

<ng-template #TableMenu>
    <div ngbDropdown placement="bottom-end" container="body">
        <a ngbDropdownToggle class="arrow-none card-drop" id="tableDropdown" href="javascript:void(0)"
            aria-expanded="false">
            <i class="mdi mdi-dots-horizontal"></i>
        </a>
        <div ngbDropdownMenu aria-labelledby="tableDropdown">
            <!-- item-->
            <a ngbDropdownItem routerLink="/">Settings</a>
            <!-- item-->
            <a ngbDropdownItem routerLink="/">Action</a>
        </div>
    </div>
</ng-template>